import SubcategoryPage from '@/components/template/SubcategoryPage';

const LeseniDodatki = () => {
  const products = [
    {
      title: "Lesena skleda Naturale",
      imageSrc: "https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80",
      url: "/dodatki/leseni/naturale"
    },
    {
      title: "Leseni podstavki Bosco",
      imageSrc: "https://images.unsplash.com/photo-1504633382448-25d6bae9c972?auto=format&fit=crop&q=80",
      url: "/dodatki/leseni/bosco"
    },
    {
      title: "Lesene okrasne figure Albero",
      imageSrc: "https://images.unsplash.com/photo-1604242684300-8c8ab367835b?auto=format&fit=crop&q=80",
      url: "/dodatki/leseni/albero"
    },
    {
      title: "Lesena dekorativna škatla Scrigno",
      imageSrc: "https://images.unsplash.com/photo-1577401239170-897942555fb3?auto=format&fit=crop&q=80",
      url: "/dodatki/leseni/scrigno"
    }
  ];

  return (
    <SubcategoryPage
      title="Leseni dodatki"
      description="Topli in naravni leseni dodatki, ki vnesejo pridih narave in domačnosti v vaš prostor."
      heroImage="https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default LeseniDodatki;